// Runtime configuration (loaded from public/config.js at runtime)
// Falls back to build-time env vars, then defaults
const config = globalThis.__RUNTIME_CONFIG__ || {};

const API_URL =
  config.API_URL || import.meta.env.VITE_API_URL || "http://localhost:8085/api";

const ENABLE_RESERVATION_IDEMPOTENCY_HEADER =
  config.ENABLE_RESERVATION_IDEMPOTENCY_HEADER === true ||
  config.ENABLE_RESERVATION_IDEMPOTENCY_HEADER === "true" ||
  import.meta.env.VITE_ENABLE_RESERVATION_IDEMPOTENCY_HEADER === "true";

export const ROOT_API_URL = API_URL;
export const RESERVATION_IDEMPOTENCY_HEADER_ENABLED =
  ENABLE_RESERVATION_IDEMPOTENCY_HEADER;
export const ADDONS_ENDPOINT = "/add-ons";
export const APPOINTMENTS_ENDPOINT = "/appointments";
export const CONTACT_ENDPOINT = "/contact";
export const EVENTS_ENDPOINT = "/events";
export const FAQS_ENDPOINT = "/faqs";
export const INVOICES_ENDPOINT = "/invoices";
export const REACTIONS_ENDPOINT = "/reactions";
export const RECEIPT_ENDPOINT = "/admin/receipts";
export const RESERVATIONS_ENDPOINT = "/reservations";
export const RESERVATIONS_AVAILABILITY_ENDPOINT = "/reservations/availability";
export const RESERVATIONS_ESTIMATE_ENDPOINT = "/reservations/estimate";
export const REVIEWS_ENDPOINT = "/reviews";
export const USERS_ENDPOINT = "/users";
export const GALLERY_ENDPOINT = "/gallery";
export const KEYCLOAK_CLIENT_ID =
  import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "le-prestige-hall-ui";

const ServerEndPoints = {
  ROOT_API_URL,
  RESERVATION_IDEMPOTENCY_HEADER_ENABLED,
  ADDONS_ENDPOINT,
  APPOINTMENTS_ENDPOINT,
  CONTACT_ENDPOINT,
  EVENTS_ENDPOINT,
  FAQS_ENDPOINT,
  INVOICES_ENDPOINT,
  REACTIONS_ENDPOINT,
  RECEIPT_ENDPOINT,
  RESERVATIONS_ENDPOINT,
  RESERVATIONS_AVAILABILITY_ENDPOINT,
  RESERVATIONS_ESTIMATE_ENDPOINT,
  REVIEWS_ENDPOINT,
  USERS_ENDPOINT,
  GALLERY_ENDPOINT,
  KEYCLOAK_CLIENT_ID,
};
export default ServerEndPoints;
